module.exports = __webpack_public_path__ + "img/australia-male.39ad363a.png";